import type { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import type { FileUploadResponse } from './file-upload-response';

export abstract class AbstractFileUploadService<ID_TYPE> {
  abstract uploadFile(file: File): Observable<FileUploadResponse<ID_TYPE>>;
  abstract uploadFiles(files: File[]): Observable<FileUploadResponse<ID_TYPE>[]>;
  abstract getById(id: ID_TYPE): Observable<FileUploadResponse<ID_TYPE>>;
  abstract getByIds(ids: ID_TYPE[]): Observable<FileUploadResponse<ID_TYPE>[]>;
  abstract remove(id: ID_TYPE): Observable<void>;
}

export const FILE_UPLOAD_SERVICE_TOKEN = new InjectionToken<AbstractFileUploadService<any>>(
  'FILE_UPLOAD_SERVICE_TOKEN',
);
